import config from "config";

const Variables = config;

export default Variables;



// WEBPACK FOOTER //
// ./src/Utils/Variables.js